import React from "react";
import {Form} from "antd";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";


// eslint-disable-next-line no-unused-vars
const OPTIONS = [
  {frq: '11', label: "SKT 3.5G"},
  {frq: '21', label: 'KT 3.5G'},
  {frq: '31', label: 'LGU+ 3.5G'},
 {frq: '12', label: "SKT 28G"},
  {frq: '22', label: 'KT 28G'},
  {frq: '32', label: 'LGU+ 28G'},
];


function WidgetBand({ options, iconCodeByFrq }) {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="대역"
        fieldName={"frq_list"}
        options={options.map(({ frq_code, label }) => ({
          value: frq_code,
          label,
          iconCode: iconCodeByFrq[frq_code],
        }))}
        colSpan={12} />
    </Form.Item>
  );
}


export default WidgetBand;
